// extracted by mini-css-extract-plugin
module.exports = {"title":"SignUpDialog_title__3rIXQ","content":"SignUpDialog_content__1MBzy","actions":"SignUpDialog_actions__XuPqp"};